import React, { useEffect, useState } from "react"
import * as Yup from "yup"
import { useFormik } from "formik"
import withRouter from "components/Common/withRouter"
import PropTypes from "prop-types"
import {
  Card,
  CardBody,
  Form,
  Row,
  Col,
  Label,
  Input,
  FormFeedback,
} from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import { createSelector } from "reselect"
import Spinners from "components/Common/Spinner"
import {
  addNewReasonMaster,
  addNewUnitMaster,
  addNewVendorTypeMaster,
  getReasonMasterDetail,
  getUnitMasterDetail,
  getVendorTypeMasterDetail,
  updateReasonMaster,
  updateUnitMaster,
  updateVendorTypeMaster,
} from "store/actions"

const NewVendorTypeMaster = props => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const vendorTypeState = state => state.vendorTypeMaster.vendorTypeDetail.data
  const loadingState = state => state.vendorTypeMaster.loading
  const [isEditMode, setIsEditMode] = useState(false)
  const vendorTypeProperties = createSelector(
    vendorTypeState,
    loadingState,
    (vendorType, loading) => {
      return {
        vendorType: vendorType,
        loading: loading,
      }
    }
  )
  const { vendorType, loading } = useSelector(vendorTypeProperties)
  const [vendorTypeId, setUnitId] = useState()
  const [isLoading, setLoading] = useState(loading)

  const Data = () => {
    try {
      const url = new URL(window.location.href)
      if (url.href.includes("edit")) {
        setIsEditMode(true)
      }

      const vendorTypeId = url.pathname.split("/settings/edit-vendor-type-master/")[1]
      setUnitId(vendorTypeId)

      dispatch(getVendorTypeMasterDetail(vendorTypeId))
    } catch (error) {
      console.error(error)
    }
  }
  useEffect(() => {
    if (location.pathname.includes("edit")) {
      Data()
    }
  }, [dispatch])

  useEffect(() => {
    if (location.pathname.includes("edit")) {
      setIsEditMode(true)
    }
  }, [location.pathname])

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: isEditMode
      ? {
        vendor_type_title: (vendorType && vendorType.vendor_type_title) || "",
          is_active: Boolean(vendorType && vendorType.is_active),
        }
      : {
        vendor_type_title: "",
          is_active: false,
        },
    validationSchema: Yup.object({
      vendor_type_title: Yup.string().required("Please Enter Vendor Type"),
      is_active: Yup.boolean(),
    }),

    onSubmit: async values => {
      if (isEditMode === true) {
        dispatch(updateVendorTypeMaster(vendorTypeId, values, props.router.navigate))
      } else if (isEditMode === false) {
        dispatch(addNewVendorTypeMaster(values, props.router.navigate))
      }
    },
  })

  return (
    <div className="page-content">
      {isLoading ? (
        <Spinners setLoading={setLoading} />
      ) : (
        <>
          <Row>
            <Col>
              <div className="d-flex gap-2 mb-3">
                <i
                  className="mdi mdi-arrow-left font-size-20"
                  style={{ color: "grey", marginRight: "15px" }}
                  onClick={() => {
                    navigate(-1)
                  }}
                ></i>

                <span
                  style={{
                    color: "black",
                    fontWeight: "500",
                    fontSize: "18px",
                  }}
                >
                  {" "}
                  {isEditMode ? "Edit Vendor Type Master" : "New Vendor Type Master"}{" "}
                </span>
              </div>
            </Col>
            <Col>
              <Breadcrumbs title="Settings / Master configuration / Vendor Type Master" />
            </Col>
          </Row>
          <div className="mt-3"></div>
          <Card>
            <CardBody>
              <Form
                autoComplete="off"
                onSubmit={e => {
                  e.preventDefault()
                  validation.handleSubmit()
                  return false
                }}
              >
                <Row>
                  <Col>
                    <div className="mb-3">
                      <Label htmlFor="formrow-unit-Input">Vendor Type*</Label>
                      <Input
                        type="text"
                        name="vendor_type_title"
                        className="form-control"
                        id="vendor_type_title"
                        placeholder="Enter Vendor Type"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.vendor_type_title || ""}
                        invalid={
                          validation.touched.vendor_type_title && validation.errors.vendor_type_title
                            ? true
                            : false
                        }
                      />
                      {validation.touched.vendor_type_title && validation.errors.vendor_type_title ? (
                        <FormFeedback type="invalid">
                          {validation.errors.vendor_type_title}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                  <Col>
                    <div className="mb-2"></div>
                    <div>
                      <Label htmlFor="formrow-ispaid-Input">Is Active</Label>
                    </div>

                    <Col lg="12">
                      <div className="form-check form-check-inline">
                        <Input
                          type="checkbox"
                          className="form-check-Input"
                          id="is_active"
                          name="is_active"
                          onChange={e => {
                            validation.setFieldValue(
                              "is_active",
                              e.target.checked
                            )
                          }}
                          checked={Boolean(validation?.values?.is_active)}
                        />
                        <Label className="form-check-Label" htmlFor="is-Active">
                          <h6>Yes</h6>
                        </Label>
                      </div>
                      {validation.touched.is_active &&
                        validation.errors.is_active && (
                          <FormFeedback type="invalid">
                            {validation.errors.is_active}
                          </FormFeedback>
                        )}
                    </Col>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="mb-3 text-end">
                      <button type="submit" className="btn btn-primary w-md">
                        {isEditMode ? "Edit" : "Submit"}
                      </button>
                    </div>
                  </Col>
                </Row>
              </Form>
            </CardBody>
          </Card>
        </>
      )}
    </div>
  )
}

export default withRouter(NewVendorTypeMaster)

NewVendorTypeMaster.propTypes = {
  history: PropTypes.object,
}
